import { Dispatch } from 'redux';

const { Button } = window.Edocat.Components;

import { addConstraint, dropValidation, removeConstraint, transitionSubmit } from '../../../actions/form';
import { ReduxComponentInterface } from '../../../../../types/Global';
import { ControlInterface } from '../../../types/FormJson';
import { difference } from 'ramda';

interface OptionInterface extends ReduxComponentInterface, ControlInterface {
  params: any;
  option: any;
  formInstanceId: string;
  innerFormInstanceId?: string;
}

class Option extends React.PureComponent<OptionInterface> {
  onClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const {
      actions,
      name,
      option: { value },
      onChange,
      params,
      formInstanceId,
      innerFormInstanceId,
    } = this.props;

    onChange([name], value, true);

    if (params.dropValidationTransitionId === value) {
      actions.dropValidation(formInstanceId, innerFormInstanceId);
    }

    const mandatoryValues = params.mandatoryValues ? params.mandatoryValues.split(',') : null;
    let nonMandatoryValues = params.nonMandatoryValues ? params.nonMandatoryValues.split(',') : null;

    const mandatoryFields = params.mandatoryFields
      ? params.mandatoryFields.split(',')
      : params.outcomeMandatory
      ? params.outcomeMandatory[value] || null
      : null;
    let nonMandatoryFields = params.nonMandatoryFields ? params.nonMandatoryFields.split(',') : null;

    if (params.outcomeMandatory) {
      const currentFieldNonMandatory = params.outcomeMandatory[value] || [];
      nonMandatoryFields = [];
      for (let key in params.outcomeMandatory) {
        if (key !== value) {
          nonMandatoryFields = [
            ...nonMandatoryFields,
            ...difference(params.outcomeMandatory[key], currentFieldNonMandatory),
          ];
        }
      }
      if (nonMandatoryFields.length > 0 || !params.outcomeMandatory[value]) {
        nonMandatoryValues = [value];
      }
    }

    if (
      (mandatoryValues && mandatoryValues.includes(value)) ||
      (params.outcomeMandatory && params.outcomeMandatory[value])
    ) {
      mandatoryFields.forEach((it: string) => {
        actions.addConstraint(
          formInstanceId,
          {
            fieldId: it,
            id: 'MANDATORY',
          },
          innerFormInstanceId
        );
      });
    } else if (nonMandatoryValues && nonMandatoryValues.includes(value)) {
      nonMandatoryFields.forEach((it: string) => {
        actions.removeConstraint(
          formInstanceId,
          {
            fieldId: it,
            id: 'MANDATORY',
          },
          innerFormInstanceId
        );
      });
    }

    actions.transitionSubmit(formInstanceId, true, innerFormInstanceId);
  };

  render() {
    const {
      option: { label },
      disabled,
    } = this.props;

    return <Button primary label={label} onClick={this.onClick} disabled={disabled} />;
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators(
    { addConstraint, removeConstraint, dropValidation, transitionSubmit },
    dispatch
  ),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(Option);
